"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      display: 'inline-block',
      cursor: 'pointer !important',
      lineHeight: '20px',
      padding: 0,
      color: theme.colors.link,
      transition: 'color .1s ease-in-out',
      border: 'none',
      outline: 'none',
      background: 'transparent',
      textDecoration: 'none',
      '&:active': {
        color: theme.colors.link
      },
      '&:hover': {
        color: theme.colors.linkDark
      },
      '& *': {
        cursor: 'pointer'
      }
    },
    isDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed !important',
      '&:hover': {
        backgroundPosition: '0 0 !important'
      },
      '& *': {
        cursor: 'not-allowed'
      }
    },
    big: (0, _extends2.default)({}, theme.typography.bigText),
    medium: (0, _extends2.default)({}, theme.typography.defaultText),
    small: (0, _extends2.default)({}, theme.typography.smallText)
  };
};

exports.default = _default;